import { useQuery } from "react-query";
import API from "../shared-utils/api";
const storageKey = (eventId) => `z_smart_coupon_${eventId}`;
const fetchSmartBookingOffer = async (params) => {
    var _a, _b;
    const persistedCouponId = typeof window !== "undefined"
        ? ((_a = localStorage.getItem(storageKey(params.eventId))) !== null && _a !== void 0 ? _a : undefined)
        : undefined;
    const queryParams = {
        event_id: params.eventId,
    };
    const resolvedCouponId = persistedCouponId !== null && persistedCouponId !== void 0 ? persistedCouponId : params.couponId;
    if (resolvedCouponId)
        queryParams.coupon_id = resolvedCouponId;
    if (params.refType)
        queryParams.ref_type = params.refType;
    if (params.refId)
        queryParams.ref_id = params.refId;
    if (params.reservationTime)
        queryParams.reservation_time = params.reservationTime;
    const { data } = await API.get("/api/v1/rbzo/coupon/customer/smart-booking-offer", { params: queryParams });
    const offer = (_b = data.data) !== null && _b !== void 0 ? _b : null;
    if (typeof window !== "undefined") {
        if (offer === null || offer === void 0 ? void 0 : offer.coupon_id) {
            localStorage.setItem(storageKey(params.eventId), String(offer.coupon_id));
        }
        else {
            localStorage.removeItem(storageKey(params.eventId));
        }
    }
    return offer;
};
export const useSmartBookingOffer = (params) => {
    var _a;
    return useQuery(["smart-booking-offer", params.eventId, (_a = params.reservationTime) !== null && _a !== void 0 ? _a : ""], () => fetchSmartBookingOffer(params), {
        retry: 1,
        enabled: !!params.eventId && !!params.reservationTime,
        refetchOnWindowFocus: false,
        keepPreviousData: true,
    });
};
